import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["isHostingCloud", "isWorkflowApp", "appName"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { H4 } from '@atlassian/mpac-primitives';
import { ExternalLink } from '@atlassian/mpac-ui';
import React from 'react';
import { PrivacySecurityDetailsNotAvailableBannerContainer, PrivacySecurityDetailsNotAvailableBannerContent } from '../../CustomerPrivacyAndSecurityTab/CustomerPrivacyAndSecurityTab.styles';
import { PSDetailsNotAvailableForDCAndServerAppsBanner } from '../PSDetailsNotAvailableForDCAndServerAppsBanner';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const PrivacySecurityDetailsNotAvailableBanner = _ref => {
  let {
      isHostingCloud,
      isWorkflowApp,
      appName
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (isWorkflowApp) {
    return /*#__PURE__*/_jsxs(PrivacySecurityDetailsNotAvailableBannerContainer, {
      children: [/*#__PURE__*/_jsx(H4, {
        as: "h2",
        children: " Privacy & Security details inapplicable "
      }), /*#__PURE__*/_jsxs(PrivacySecurityDetailsNotAvailableBannerContent, {
        children: [appName, " is a workflow app and can't be installed. The privacy and security questionnaire is not applicable to this app."]
      })]
    });
  }
  if (isHostingCloud) {
    return /*#__PURE__*/_jsxs(PrivacySecurityDetailsNotAvailableBannerContainer, {
      children: [/*#__PURE__*/_jsx(H4, {
        as: "h2",
        children: " This app is owned and maintained by Atlassian "
      }), /*#__PURE__*/_jsxs(PrivacySecurityDetailsNotAvailableBannerContent, {
        children: ["Atlassian-owned apps follow Atlassian's privacy and security policies. You can find more information on the policies at the", ' ', /*#__PURE__*/_jsx(ExternalLink, {
          href: "https://www.atlassian.com/trust",
          children: " Trust Center "
        }), "and in the", ' ', /*#__PURE__*/_jsx(ExternalLink, {
          href: "https://www.atlassian.com/legal/data-processing-addendum",
          children: "Atlassian Customer DPA"
        }), "."]
      })]
    });
  }
  return /*#__PURE__*/_jsx(PSDetailsNotAvailableForDCAndServerAppsBanner, _objectSpread({}, rest));
};